import request from '@/utils/request'

/**
 * 获取菜单列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listMenus(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menu.listMenus',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取菜单组列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listMenuGroups(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuGroup.listMenuGroups',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新菜单
 * @param {Object} data 菜单数据
 * @returns {Promise} Promise对象
 */
export function updateMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menu.updateMenu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除菜单
 * @param {Object} data 菜单数据
 * @returns {Promise} Promise对象
 */
export function deleteMenu(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menu.deleteMenu',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}